import _ from 'lodash'
import React from 'react'
import T from 'prop-types'
import SortableMenu from '../sortable-menu/SortableMenu'
import ColumnShape from './ColumnShape'

class ColumnOrderConfig extends React.Component {
  constructor(props) {
    super(props)

    this._onSaveClick = this._onSaveClick.bind(this)
    this._bindMenuRef = this._bindMenuRef.bind(this)
  }

  _onSaveClick() {
    this.props.onSave(_.pluck(this._sortableMenu.getActiveItems(), 'id'))
  }

  _bindMenuRef(menu) {
    this._sortableMenu = menu
  }

  render() {
    const { props } = this
    return (
      <div className="data_table_cfg_dialog bulk_update_overlay">
        <span className="remove_btn" onClick={props.onCancel} />
        <div>
          <h1>Configure Columns</h1>
          <p>
            Modify column order and visibility for this table. Drag column names
            to their desired locations below.
            <span className="btn btn-link" onClick={props.onReset}>
              Reset to Default
            </span>
          </p>
        </div>
        <div className="explorer_sortable_menu_wrap">
          <SortableMenu
            allItems={props.columns.reduce((out, col) => {
              if (!col.fixed) {
                //ignore fixed columns
                out.push({
                  id: col.key,
                  display: col.headerText || col.header
                })
              }
              return out
            }, [])}
            defaultItemIds={props.columnOrder}
            ref={this._bindMenuRef}
            touchBackendEnabled={false}
          />
        </div>
        <div className="dialog_buttons">
          <button className="btn btn-large" onClick={props.onCancel}>
            Cancel
          </button>
          <div className="dialog_primary_button_wrap">
            <button className="btn btn-primary" onClick={this._onSaveClick}>
              Save and Close
            </button>
          </div>
        </div>
      </div>
    )
  }
}

ColumnOrderConfig.displayName = 'DataTable_ColumnSorterOverlay'
ColumnOrderConfig.propTypes = {
  columns: T.arrayOf(T.shape(ColumnShape)), //all available column defs
  columnOrder: T.arrayOf(T.string), //current order
  onSave: T.func.isRequired, //(arrayOfColKeys)
  onReset: T.func.isRequired,
  onCancel: T.func.isRequired
}

export default ColumnOrderConfig
